import ticket from '../../assets/ticket.svg';
import ticketDark from '../../assets/ticket-dark.svg';
import './CardCupomApplied.css';

import { CardCupomDetailsData } from '../cardCuponDetails/CardCupomDetails';

export interface CardCupomAppliedProps {
  onClick: () => void;
  data: CardCupomDetailsData;
}

export const CardCupomApplied = ({ data, onClick }: CardCupomAppliedProps) => {
  const { dcCode, dcParameter, applicationName } = data;
  return (
    <div className='coupon-wrapper'>
      <div className='coupon-container' onClick={onClick}>
        <div className={`coupon-card-toast${dcCode ? ' applied' : ''}`}>
          <div className='coupon-card-toast__icon'>
            <img
              src={dcCode ? ticket : ticketDark}
              alt='ticket'
              className='coupon-card-toast__icon-img'
            />
          </div>
          <div className='coupon-card-toast__texts'>
            <div className='coupon-card-toast__name'>{dcCode || 'Cupom'}</div>
            <div className='coupon-card-toast__discount'>
              {dcParameter ? (
                <>
                  <div>{`${dcParameter}% OFF`}</div>
                  {/* <div className='coupon-applied-brand'>
                    Válido nos pontos de recarga {applicationName}
                  </div> */}
                  {/* <div className='coupon-applied-brand'>
                    *Válido somente entre {'18:00'} e {'22:00'}
                  </div>
                  <div className='coupon-applied-brand'>
                    **Válido somente para recaras acima de R$ {'20,00'}
                  </div> */}
                </>
              ) : (
                'Digite um código'
              )}
            </div>
          </div>
          <span className='coupon-card-toast__change'>
            {dcCode ? 'Alterar' : 'Adicionar'}
          </span>
        </div>
      </div>
    </div>
  );
};
